import type { SVGProps } from 'react';

const SvgInformationOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.5 2a1 1 0 1 0 0 2h.5v3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2v-5z"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgInformationOutline;
